import { Injectable } from '@angular/core';
import { IhmNotificationMessage } from '../interfaces/ihm-notifications.interface';
import * as _ from 'lodash';
import * as momentImported from 'moment';
const moment = momentImported;

@Injectable()
export class IhmNotificationsService {
  readonly DATE_FORMAT_FOR_GROUP_NAME: string = 'YYYY-MM-DD';
  readonly MAX_AGE_IN_DAYS: number = 14;
  private sampleNotifications: IhmNotificationMessage[];

  constructor() {
    this.sampleNotifications = this.generateSampleNotifications();
  }

  public getSampleNotifications(): IhmNotificationMessage[] {
    return this.sampleNotifications;
  }

  private generateSampleNotifications(): IhmNotificationMessage[] {
    const notifications: IhmNotificationMessage[] = [];

    let currentDate: Date;
    let sample: IhmNotificationMessage;

    for (let dayOffset: number = 0; dayOffset < this.MAX_AGE_IN_DAYS; dayOffset++) {
      currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - dayOffset);

      sample = {
        // This special key is for refreshing the page in the same day, having a bunch of unread messages as sample.
        key: 'key-a:' + (dayOffset < 2 ? currentDate.toString() : moment(currentDate.getDate()).format(this.DATE_FORMAT_FOR_GROUP_NAME)),
        description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit,
          sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
          nisi ut aliquip ex ea commodo consequat.`,
        date: currentDate
      };

      notifications.push(sample);

      sample = {
        // This special key is for refreshing the page in the same day, having a bunch of unread messages as sample.
        key: 'key-b:' + (dayOffset < 1 ? currentDate.toString() : moment(currentDate.getDate()).format(this.DATE_FORMAT_FOR_GROUP_NAME)),
        description: `Ut enim ad minim veniam, quis nostrud exercitation
        ullamco laboris nisi ut aliquip ex ea commodo consequat.`,
        date: currentDate
      };

      notifications.push(sample);
    }

    return _.shuffle(notifications);
  }
}
